import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 54 39",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M48 0H9.75L28.5 12.75H54V6a6 6 0 0 0-6-6z\" fill=\"#DE3830\"></path><path d=\"M9.75 39H48a6 6 0 0 0 6-6v-6.75H28.5L9.75 39z\" fill=\"#002395\"></path><path fill=\"#141414\" d=\"M0 9v21l15.75-10.5z\"></path><path fill=\"#FFB611\" d=\"M0 6v3l15.75 10.5L0 30v3l20.25-13.5z\"></path><path d=\"M5.311.042A6 6 0 0 0 0 6l20.25 13.5L0 33a6 6 0 0 0 5.311 5.958L27.75 23.25H54v-7.5H27.75L5.311.042z\" fill=\"#007A4D\"></path><path d=\"M9.75 0H6c-.234 0-.462.017-.689.042L27.75 15.75H54v-3H28.5L9.75 0zM5.311 38.958c.227.026.455.042.689.042h3.75L28.5 26.25H54v-3H27.75L5.311 38.958z\" fill=\"#EEE\"></path></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }